import { render, staticRenderFns } from "./view-shipment.vue?vue&type=template&id=73148e3e&scoped=true"
import script from "./view-shipment.vue?vue&type=script&lang=js"
export * from "./view-shipment.vue?vue&type=script&lang=js"
import style0 from "./view-shipment.vue?vue&type=style&index=0&id=73148e3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73148e3e",
  null
  
)

export default component.exports